import { formatStatusOverTimeLabel } from './campaignStatusOverTimeAdapter'

const EMPTY_COMPLETION_PROGRESS = {
  available: false,
  assigned: null,
  labels: [],
  allCompany: [],
  departments: [],
  deadlineIndex: null,
  extendedDeadlineIndex: null,
  todayIndex: null,
  campaignState: 'active',
  empty: true,
}

const lastNonNullIndex = (values) => {
  for (let i = values.length - 1; i >= 0; i -= 1) {
    if (values[i] != null) {
      return i
    }
  }
  return null
}

export const toCompletionPct = (count, total) => {
  if (count == null) {
    return null
  }
  if (!total) {
    return 0
  }
  return Math.round((count / total) * 100)
}

const mapSeries = (series, total) => (series || []).map((value) => toCompletionPct(value, total))

export const adaptCampaignCompletionProgress = (payload) => {
  if (payload == null || payload.assigned == null) {
    return EMPTY_COMPLETION_PROGRESS
  }

  const assigned = payload.assigned
  const allCompanyCounts = payload.allCompany || []
  const todayIndex = lastNonNullIndex(allCompanyCounts)
  const lastPoint = allCompanyCounts.length ? allCompanyCounts[allCompanyCounts.length - 1] : null

  return {
    available: true,
    assigned,
    labels: (payload.labels || []).map(formatStatusOverTimeLabel),
    allCompany: mapSeries(allCompanyCounts, assigned),
    departments: (payload.departments || []).map((department) => {
      const size = department.assigned || 0
      const done = department.completed || 0
      const late = department.completedLate || 0

      return {
        name: department.name,
        size,
        done,
        late,
        pct: toCompletionPct(done, size) || 0,
        latePct: toCompletionPct(late, size) || 0,
        series: mapSeries(department.series, size),
      }
    }),
    deadlineIndex: payload.deadlineIndex ?? null,
    extendedDeadlineIndex: payload.extendedDeadlineIndex ?? null,
    todayIndex,
    campaignState: lastPoint != null ? 'completed' : 'active',
    empty: allCompanyCounts.every((value) => !value),
  }
}
